import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../components/toast/ErrorToast";
import DateAdapter from "../../adapters/DateAdapter";

export default class OrderLogFeature {

    constructor(application, navigator, orderNumber) {
        this._application = application;
        this._navigate = navigator;
        this._loaded = false;
        this._orderActionsRegister = []
        this._orderNumber = orderNumber

        makeObservable(this, {
            _loaded: observable,
            loaded: computed,
            _orderActionsRegister: observable,
            orderActionsRegister: computed,
        })
    }

    async load() {
        await this._getOrderActionsRegister(this._orderNumber)
        this.finishLoading()
    }

    finishLoading() {
        this._loaded = true
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get orderActionsRegister() {
        return this._orderActionsRegister;
    }

    set orderActionsRegister(value) {
        this._orderActionsRegister = value;
    }


    columns() {
        return [
            {id: 'executor', label: 'Usuario'},
            {id: 'action', label: 'Accion'},
            {id: 'executionTimestamp', label: 'Horario'}
        ];
    }

    presentedOrderLogs() {
        return this._orderActionsRegister.map((orderActionRegister, index) => {
            return this._presentOrderActionRegister(orderActionRegister, index);
        });
    }

    _presentOrderActionRegister(orderActionRegister, index) {
        const dateAdapter = new DateAdapter('DD-MM-YYYY HH:mm:ss')
        return {
            id: index,
            executionTimestamp: dateAdapter.adapt(orderActionRegister.executionTimestamp),
            executor: orderActionRegister.executor,
            action: this.adaptAction(orderActionRegister.action)
        }
    }

    adaptAction(orderAction) {
        if (orderAction === "CREATE") {
            return "CREACION DEL PEDIDO"
        }
        if (orderAction === "EDIT") {
            return "EDICION DEL PEDIDO"
        }
        if (orderAction === "DELETE") {
            return "PEDIDO BORRADO"
        }
        if (orderAction === 'CHANGE_STATE_TO_INITIAL_ACTION') {
            return "CAMBIO DE ESTADO: ABIERTO"
        }
        if (orderAction === 'CHANGE_STATE_TO_PENDING_ACTION') {
            return "CAMBIO DE ESTADO: CERRADO"
        }
        if (orderAction === 'CHANGE_STATE_TO_CONFIRMED_ACTION') {
            return "CAMBIO DE ESTADO: PROCESO DE FACTURACIÓN"
        }
        if (orderAction === 'CHANGE_STATE_TO_FAILED_TO_CONFIRM_ACTION'){
            return "FALLO EN TRANSMISIÓN AL ERP"
        }
        if (orderAction === 'CHANGE_STATE_TO_TRANSMITTING_ACTION'){
            return "CAMBIO DE ESTADO: EN TRANSMISIÓN"
        }
        if (orderAction === 'CHANGE_STATE_TO_REVISION'){
            return "CAMBIO DE ESTADO: REVISION"
        }
        if (orderAction === 'CHANGE_STATE_TO_REJECTED'){
            return "CAMBIO DE ESTADO: RECHAZADO"
        }
        if (orderAction === 'CHANGE_STATE_TO_REVISION'){
            return "CAMBIO DE ESTADO: REVISION"
        }
    }

    async _getOrderActionsRegister() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.orderActionsRegister = response.orderLog();
            },
            handlesError: (response) => {
                errorToast('No se pudo obtener el pedido')
            }
        });
        return this._application.apiClient().orderLog(this._orderNumber, responseHandler)
    }
}